/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import ListAltIcon from '@material-ui/icons/ListAlt';
import SettingsIcon from '@material-ui/icons/SettingsOutlined';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import DashboardSharpIcon from '@material-ui/icons/DashboardSharp';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import { Label } from 'components';
import AssessmentIcon from '@material-ui/icons/Assessment';
import ViewListIcon from '@material-ui/icons/ViewList';
import PermMediaIcon from '@material-ui/icons/PermMedia';
import ViewCarouselIcon from '@material-ui/icons/ViewCarousel';
import InboxIcon from '@material-ui/icons/Inbox';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import AddAlertOutlinedIcon from '@material-ui/icons/AddAlertOutlined';
export default [
  {
    title: '',
    pages: [
      // {
      //   title: 'Overview',
      //   href: '/overview',
      //   icon: HomeIcon
      // },
      {
        title: 'Dashboard',
        href: '/dashboard',
        icon: DashboardSharpIcon,
      },
      // {
      //   title: 'Manage Banners',
      //   href: '/banners',
      //   icon: DashboardSharpIcon,
      // },
      {
          title: 'Manage Banners',
          href: '/',
          icon: ViewCarouselIcon,
          children: [
            {
              title: 'Banners for App',
              href: '/banners'
            },
            {
              title: 'Banners for Web',
              href: '/banners-web'
            }
          ]
        },
      {
        title: 'Manage Catagories',
        href: '/catagories',
        icon: InboxIcon,
      },
      {
        title: 'Manage Sub Catagories',
        href: '/sub-catagories',
        icon: AllInboxIcon,
      },
      {
        title: 'Manage Catalogs',
        href: '/catalogs',
        icon: ViewListIcon,
      },
      {
        title: 'Manage Catalogs v2',
        href: '/catalogsnew',
        icon: ViewListIcon,
      },
      {
        title: 'Manage Brands',
        href: '/brands',
        icon: PermMediaIcon,
      },
      {
        title: 'Manage Customers',
        href: '/customers',
        icon: PeopleAltIcon,
      },
      {
        title: 'Manage Orders',
        href: '/orders',
        icon: ListAltIcon,
      },
      {
        title: 'Manage Contact Request',
        href: '/contact-requests',
        icon: ContactPhoneIcon,
      },
      {
        title: 'Manage Reports',
        href: '/create-report',
        icon: AssessmentIcon,
      },
      {
        title: 'Manage CMS Pages',
        href: '/cms-pages',
        icon: LibraryBooksIcon,
      },
      {
        title: 'Send Push Notification',
        href: '/send_push_notification',
        icon: AddAlertOutlinedIcon,
      },

      {
        title: 'Settings',
        href: '/settings/general',
        icon: SettingsIcon,
        // children: [
        //   {
        //     title: 'General',
        //     href: '/settings/general'
        //   },
        //   {
        //     title: 'Security',
        //     href: '/settings/security'
        //   }
        // ]
      },
      // {
      //   title: 'Dashboards',
      //   href: '/dashboards',
      //   icon: DashboardIcon,
      //   children: [
      //     {
      //       title: 'Default',
      //       href: '/dashboards/default'
      //     },
      //     {
      //       title: 'Analytics',
      //       href: '/dashboards/analytics'
      //     }
      //   ]
      // },
      // {
      //   title: 'Management',
      //   href: '/management',
      //   icon: BarChartIcon,
      //   children: [
      //     {
      //       title: 'Customers',
      //       href: '/management/customers'
      //     },
      //     {
      //       title: 'Customer Details',
      //       href: '/management/customers/1/summary'
      //     },
      //     {
      //       title: 'Projects',
      //       href: '/management/projects'
      //     },
      //     {
      //       title: 'Orders',
      //       href: '/management/orders'
      //     },
      //     {
      //       title: 'Order Details',
      //       href: '/management/orders/1'
      //     }
      //   ]
      // },
      // {
      //   title: 'Social Feed',
      //   href: '/social-feed',
      //   icon: PeopleIcon
      // },
      // {
      //   title: 'Profile',
      //   href: '/profile',
      //   icon: PersonIcon,
      //   children: [
      //     {
      //       title: 'Timeline',
      //       href: '/profile/1/timeline'
      //     },
      //     {
      //       title: 'Connections',
      //       href: '/profile/1/connections'
      //     },
      //     {
      //       title: 'Projects',
      //       href: '/profile/1/projects'
      //     },
      //     {
      //       title: 'Reviews',
      //       href: '/profile/1/reviews'
      //     }
      //   ]
      // },
      // {
      //   title: 'Project',
      //   href: '/projects',
      //   icon: FolderIcon,
      //   children: [
      //     {
      //       title: 'Browse',
      //       href: '/projects'
      //     },
      //     {
      //       title: 'Create',
      //       href: '/projects/create'
      //     },
      //     {
      //       title: 'Overview',
      //       href: '/projects/1/overview'
      //     },
      //     {
      //       title: 'Files',
      //       href: '/projects/1/files'
      //     },
      //     {
      //       title: 'Activity',
      //       href: '/projects/1/activity'
      //     },
      //     {
      //       title: 'Subscribers',
      //       href: '/projects/1/subscribers'
      //     }
      //   ]
      // },
      // {
      //   title: 'Invoice',
      //   href: '/invoices/1',
      //   icon: ReceiptIcon
      // },
      // {
      //   title: 'Kanban Board',
      //   href: '/kanban-board',
      //   icon: ListAltIcon
      // },
      // {
      //   title: 'Mail',
      //   href: '/mail',
      //   icon: MailIcon,
      //   label: () => (
      //     <Label
      //       color={colors.red[500]}
      //       shape="rounded"
      //     >
      //       2
      //     </Label>
      //   )
      // },
      // {
      //   title: 'Chat',
      //   href: '/chat',
      //   icon: ChatIcon,
      //   label: () => (
      //     <Label
      //       color={colors.red[500]}
      //       shape="rounded"
      //     >
      //       4
      //     </Label>
      //   )
      // },
      // {
      //   title: 'Calendar',
      //   href: '/calendar',
      //   icon: CalendarTodayIcon,
      //   label: () => <Label color={colors.green[500]}>New</Label>
      // },
      // {
      //   title: 'Settings',
      //   href: '/settings',
      //   icon: SettingsIcon,
      //   children: [
      //     {
      //       title: 'General',
      //       href: '/settings/general'
      //     },
      //     {
      //       title: 'Subscription',
      //       href: '/settings/subscription'
      //     },
      //     {
      //       title: 'Notifications',
      //       href: '/settings/notifications'
      //     },
      //     {
      //       title: 'Security',
      //       href: '/settings/security'
      //     }
      //   ]
      // },
      // {
      //   title: 'Authentication',
      //   href: '/auth',
      //   icon: LockOpenIcon,
      //   children: [
      //     {
      //       title: 'Login',
      //       href: '/auth/login'
      //     },
      //     {
      //       title: 'Register',
      //       href: '/auth/register'
      //     }
      //   ]
      // },
      // {
      //   title: 'Errors',
      //   href: '/errors',
      //   icon: ErrorIcon,
      //   children: [
      //     {
      //       title: 'Error 401',
      //       href: '/errors/error-401'
      //     },
      //     {
      //       title: 'Error 404',
      //       href: '/errors/error-404'
      //     },
      //     {
      //       title: 'Error 500',
      //       href: '/errors/error-500'
      //     }
      //   ]
      // }
    ]
  },
  // {
  //   title: 'Support',
  //   pages: [
  //     {
  //       title: 'Presentation',
  //       href: '/presentation',
  //       icon: PresentToAllIcon
  //     },
  //     {
  //       title: 'Getting started',
  //       href: '/getting-started',
  //       icon: CodeIcon
  //     },
  //     {
  //       title: 'Changelog',
  //       href: '/changelog',
  //       icon: ViewModuleIcon,
  //       label: () => <Label color={colors.blue['500']}>v1.2.0</Label>
  //     }
  //   ]
  // }
];
